module.exports = __webpack_public_path__ + "static/p-logo--repeatplus-c0c5e70c51c3648d6a204afc0565ec3f.png";